(() => {
  const init = () => {
    const dialog = document.getElementById('AmbassadorDialog');
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const form = dialog.querySelector('form');
    const storageKey = 'caene-ambassador-pending';
    let trigger;
    const readPending = () => { try { return JSON.parse(sessionStorage.getItem(storageKey)); } catch { return null; } };
    const clearPending = () => { try { sessionStorage.removeItem(storageKey); } catch { /* Storage can be unavailable. */ } };
    const open = () => {
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('caene-ambassador-open');
      dialog.querySelector('h2').focus({ preventScroll: true });
    };
    document.querySelectorAll('[data-ambassador-open]').forEach(button => {
      button.addEventListener('click', () => { trigger = button; open(); });
    });
    dialog.querySelectorAll('[data-ambassador-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('caene-ambassador-open');
      if (trigger) trigger.focus({ preventScroll: true });
    });
    // Native Shopify submission preserves its spam protection and server validation.
    form.addEventListener('submit', () => {
      const values = {};
      form.querySelectorAll('input:not([type="hidden"])').forEach(input => { values[input.name] = input.value; });
      try { sessionStorage.setItem(storageKey, JSON.stringify({ time: Date.now(), values })); } catch { /* Submission still works without storage. */ }
    });
    const pending = readPending();
    const recent = pending && Date.now() - pending.time < 30 * 60 * 1000;
    const returnedHere = location.hash === '#AmbassadorApplication';
    if ((returnedHere || recent) && dialog.querySelector('[data-ambassador-success]')) {
      clearPending();
      open();
    } else if (recent && dialog.querySelector('[data-ambassador-error]')) {
      Object.entries(pending.values).forEach(([name, value]) => {
        const input = form.elements.namedItem(name);
        if (input) input.value = value;
      });
      open();
    } else if (pending && !recent) clearPending();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
